<form class="iot4bos-ui-backoffice-filter-bp-by-name-form full-width">
  <mat-form-field class="name-field" color="accent">
    <mat-icon class="search-icon" matIconPrefix>search</mat-icon>
    <mat-label>{{ 'I18N_ADMIN.BUSINESS_PROFILES.FILTER_PLACEHOLDER' | translate }}</mat-label>
    <input #search (keyup)="filter.emit(search.value)" [value]="searchString()" matInput />
  </mat-form-field>
</form>
